import * as React from "react"

function DashboardIcon(props) {
    return (
        <svg width="100%" height="100%" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M1.17 11.111h7.017c.31 0 .608-.117.827-.325.22-.209.343-.491.343-.786V1.111c0-.295-.123-.577-.343-.786A1.202 1.202 0 008.187 0H1.17C.86 0 .562.117.343.325.123.534 0 .816 0 1.111V10c0 .295.123.577.343.786.219.208.516.325.827.325zM0 18.89c0 .295.123.577.343.786.219.208.516.325.827.325h7.017c.31 0 .608-.117.827-.325.22-.209.343-.491.343-.786v-4.445c0-.294-.123-.577-.343-.785a1.201 1.201 0 00-.827-.326H1.17c-.31 0-.608.117-.827.326-.22.208-.343.49-.343.785v4.445zm11.696 0c0 .295.123.577.343.786.219.208.516.325.827.325h7.017c.31 0 .608-.117.827-.325.22-.209.343-.491.343-.786V11.11c0-.295-.124-.577-.343-.786a1.202 1.202 0 00-.827-.325h-7.017c-.31 0-.608.117-.827.325-.22.209-.343.491-.343.786v7.778zm1.17-11.111h7.017c.31 0 .608-.117.827-.326.22-.208.343-.49.343-.785V1.11c0-.295-.124-.577-.343-.786A1.202 1.202 0 0019.883 0h-7.017c-.31 0-.608.117-.827.325-.22.209-.343.491-.343.786v5.556c0 .294.123.577.343.785.219.209.516.326.827.326z"
                fill={props.fill}
            />
        </svg>
    )
}

export default DashboardIcon
